import * as types from './mutation-types'

export default {
  [types.AUTHENTICATE] (state, payload) {
    state.user = payload
  },
  [types.SIGNOUT] (state) {
    state.user = null
  },
  [types.ATTRIBUTES] (state, payload) {
    state.user.attributes = payload
  },
  [types.CREDENTIALS] (state, payload) {
    state.user.credentials = payload
  },
  [types.AUTH_CHALLENGE] (state, payload) {
    // do a merge
    state.user_auth_challenge = { ...(state.user_auth_challenge || {}), ...(payload || {}) }
  }
}
